import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";
import { FormProvider, type UseFormReturn } from "react-hook-form";

import { Button } from "@/common/components/button/button";
import { InputField } from "@/common/components/form/input-field/input-field";

import { PostalCodeField } from "./postal-code-field";

type Fields = {
  postalCode: string;
  name: string;
  address: string;
  companyId: string;
};

const StorageForm = ({
  form,
  onSubmit,
  children,
  buttons,
}: React.PropsWithChildren<{
  form: UseFormReturn<Fields>;
  onSubmit: (params: Fields) => void;
  buttons: React.ReactNode;
}>) => {
  const transformData = (data: Fields): Fields => {
    return {
      ...data,
      postalCode: data.postalCode.split(" ")[0],
    };
  };

  return (
    <FormProvider {...form}>
      <form
        className="flex grow flex-col gap-y-4"
        id="storage-form"
        onSubmit={form.handleSubmit((data) => onSubmit(transformData(data)))}
      >
        <fieldset className="flex flex-col gap-y-6">
          <InputField<Fields>
            autoComplete="off"
            label={<Trans>Název skladu</Trans>}
            name="name"
            options={{
              required: t`Vyplňte prosím název skladu`,
            }}
          />

          <InputField<Fields>
            autoComplete="off"
            label={<Trans>Adresa skladu</Trans>}
            name="address"
            options={{
              required: t`Vyplňte prosím adresu skladu`,
            }}
          />

          <div className="relative">
            <PostalCodeField.Provider>
              <PostalCodeField label={<Trans>PSČ skladu</Trans>} />
              <PostalCodeField.Suggestions />
            </PostalCodeField.Provider>
          </div>
        </fieldset>
        {children}
      </form>
      <Button.Container>{buttons}</Button.Container>
    </FormProvider>
  );
};

export { StorageForm };
export type { Fields };
